declare const firebase: any;

var Firebase = (function () {
  var instance: any;
  function init() {
    var config = {
      apiKey: "AIzaSyBo2vtTAXYUBRcVz4ezBhMqkkk3fYIeBME",
      authDomain: "safsal-league.firebaseapp.com",
      databaseURL: "https://safsal-league.firebaseio.com",
      projectId: "safsal-league",
      storageBucket: "safsal-league.appspot.com",
      messagingSenderId: "367666937987",
      appId: "1:367666937987:web:204fa0eb346d40260b9bb6",
      measurementId: "G-SJXGZ7MW7X",
    };
    var auth: any;
    var db: any;
    var analytics: any;
    var profile: any = null; // the user
    var updated: boolean = false; // whether or not the data is updated
    var authYes = new Event("authYes");
    var authNo = new Event("authNo");
    var authChange = new Event("authChange");
    var updateEvent = new Event("updated");
    function update() {
      // sets data as updated
      updated = true;
      document.dispatchEvent(updateEvent);
    }
    if (!firebase.apps.length) {
      firebase.initializeApp(config);
    }
    auth = firebase.auth();
    db = firebase.database();
    if (window.location.hostname !== "localhost") analytics = firebase.analytics();
    auth.onAuthStateChanged((user: any) => {
      // if user is logged
      if (user) {
        profile = user;
        update();
        document.dispatchEvent(authYes);
      } else {
        profile = null;
        update();
        document.dispatchEvent(authNo);
      }
      document.dispatchEvent(authChange);
    });
    return {
      signin: function (email: string, pass: string) {
        // signs in to account
        updated = false;
        return new Promise(async (resolve) => {
          try {
            await auth.signInWithEmailAndPassword(email, pass);
            update();
            resolve(true);
          } catch (e) {
            update();
            resolve(e);
          }
        });
      },
      googleSignin: function () {
        return new Promise(async (resolve) => {
          const provider = new firebase.auth.GoogleAuthProvider();
          auth
            .signInWithPopup(provider)
            .then((result: any) => {
              update();
              resolve(true);
            })
            .catch((e: any) => {
              console.log(e);
              resolve(e);
            });
        });
      },
      register: function (email: string, pass: string) {
        // registers
        updated = false;
        return new Promise(async (resolve) => {
          try {
            await auth.createUserWithEmailAndPassword(email, pass);
            update();
            resolve(true);
          } catch (e) {
            update();
            resolve(e);
          }
        });
      },
      setUserData: function (nickname: any) {
        return new Promise(async (resolve) => {
          await this.updateData("users/public/$uid", { nickname });
          resolve(true);
        });
      },
      verifyEmail: function () {
        return new Promise(async (resolve) => {
          var user: any = await this.getUser();
          user
            .sendEmailVerification()
            .then(() => {
              // Email sent.
              resolve(true);
            })
            .catch(function (error: any) {
              // An error happened.
              console.log(error);
              resolve(error);
            });
        });
      },
      linkPhone: function (phone: any, appVerifier: any) {
        return new Promise(async (resolve) => {
          var user: any = await this.getUser();
          user
            .linkWithPhoneNumber(phone, appVerifier)
            .then(function (confirmationResult: any) {
              // SMS sent. Prompt user to type the code from the message, then sign the
              // user in with confirmationResult.confirm(code).
              resolve(confirmationResult);
            })
            .catch(function (error: any) {
              // Error; SMS not sent
              console.log(error);
              resolve(error);
            });
        });
      },
      linkPhoneCheckCode: function (confirmationResult: any, code: any) {
        return new Promise(async (resolve) => {
          confirmationResult
            .confirm(code)
            .then(function (result: any) {
              // User signed in successfully.
              resolve(true);
            })
            .catch(function (error: any) {
              // User couldn't sign in (bad verification code?)
              console.log(error);
              resolve(error);
            });
        });
      },
      unlinkProvider: function (providerID: any) {
        return new Promise(async (resolve) => {
          var user: any = await this.getUser();
          await user.unlink(providerID);
          resolve(true);
        });
      },
      userProvidersIDs: function () {
        return new Promise(async (resolve) => {
          var user: any = await this.getUser();
          var arr: any = [];
          user.providerData.forEach((provider: any) => {
            arr.push(provider.providerId);
          });
          resolve(arr);
        });
      },
      phoneProviderID: "phone",
      EmailAuthProvider: "password",
      recaptchaVerifier: function (containerID: any) {
        return new Promise(async (resolve) => {
          const recaptchaVerifier = new firebase.auth.RecaptchaVerifier(containerID, {
            size: "normal", //"invisible","compact"
            callback: function (response: any) {},
          });
          recaptchaVerifier.render().then(function (widgetId: any) {
            resolve(recaptchaVerifier);
          });
        });
      },
      analyticsEvent: function (event: any, data: any) {
        return new Promise(async (resolve) => {
          if (analytics) await analytics.logEvent(event, data);
          resolve(true);
        });
      },
      resetEmail: function (email: any) {
        return new Promise(async (resolve) => {
          auth
            .sendPasswordResetEmail(email)
            .then(function () {
              // Email sent.
              resolve(true);
            })
            .catch(function (error: any) {
              // An error happened.
              console.log(error);
              resolve(error);
            });
        });
      },
      signout: function () {
        // signs out of account
        updated = false;
        auth.signOut();
        update();
      },
      getUser: function () {
        // returns the user object
        return new Promise((resolve) => {
          if (updated) {
            resolve(profile);
          }
          document.addEventListener(
            "updated",
            function fin() {
              resolve(profile);
            },
            { once: true }
          );
        });
      },
      formatRef: async function (ref: string) {
        // formats the ref to a location in the DB
        if (ref.includes("$uid")) {
          var user: any = await this.getUser();
          if (user) {
            ref = ref.replace("$uid", user.uid);
          } else ref = ref.replace("$uid", "anonymous");
        }
        return ref;
      },
      setData: async function (ref: string, data: any) {
        // sets data in ref of DB
        ref = await this.formatRef(ref);
        return new Promise((resolve) => {
          db.ref(ref)
            .set(data)
            .then(() => {
              resolve(true);
            })
            .catch(function (error: any) {
              // An error happened.
              console.log(error);
              resolve(error);
            });
        });
      },
      updateData: async function (ref: string, data: any) {
        // updates data in ref of DB
        ref = await this.formatRef(ref);
        return new Promise((resolve) => {
          db.ref(ref)
            .update(data)
            .then(() => {
              resolve(true);
            })
            .catch(function (error: any) {
              // An error happened.
              console.log(error);
              resolve(error);
            });
        });
      },
      isEditor: function () {
        return new Promise(async (resolve) => {
          const test = await this.updateData("/", { test: "test" });
          resolve(!test.message);
        });
      },
      reauth: async function (pass: any) {
        var user: any = await this.getUser();
        var cred = await firebase.auth.EmailAuthProvider.credential(user.email, pass);
        return await user.reauthenticateWithCredential(cred);
      },
      updateEmail: function (newEmail: any, pass: any) {
        return new Promise(async (resolve) => {
          var user: any = await this.getUser();
          await this.reauth(pass);
          user
            .updateEmail(newEmail)
            .then(() => {
              // Update successful.
              resolve(true);
            })
            .catch(function (error: any) {
              // An error happened.
              console.log(error);
              resolve(error);
            });
        });
      },
      updatePassword: function (pass: any, newPass: any) {
        return new Promise(async (resolve) => {
          var user: any = await this.getUser();
          await this.reauth(pass);
          user
            .updatePassword(newPass)
            .then(() => {
              // Update successful.
              resolve(true);
            })
            .catch(function (error: any) {
              // An error happened.
              console.log(error);
              resolve(error);
            });
        });
      },
      deleteUser: function (pass: any) {
        return new Promise(async (resolve) => {
          var user: any = await this.getUser();
          if (pass) await this.reauth(pass);
          // await this.setData("/users/$uid", null);
          user
            .delete()
            .then(() => {
              // User deleted.
              resolve(true);
            })
            .catch(function (error: any) {
              // An error happened.
              console.log(error);
              resolve(error);
            });
        });
      },
      addData: async function (ref: string, data: any) {
        // adds data in ref of DB
        ref = await this.formatRef(ref);
        db.collection(ref).add(data);
      },
      deleteData: async function (ref: string) {
        // deletes data in ref of DB
        ref = await this.formatRef(ref);
        return new Promise((resolve) => {
          db.doc(ref)
            .delete()
            .then(function () {
              resolve(true);
            });
        });
      },
      readData: async function (ref: string) {
        // reads data in ref of DB
        ref = await this.formatRef(ref);
        return new Promise((resolve) => {
          db.ref(ref)
            .orderByKey()
            .once("value")
            .then((data: any) => {
              // do some stuff once
              resolve(data.val());
            })
            .catch(function (error: any) {
              // An error happened.
              console.log(error);
              resolve(error);
            });
        });
      },
    };
  }
  return {
    getInstance: function () {
      if (!instance) instance = init();
      return instance;
    },
  };
})();
export default Firebase;
